import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";

const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const getDashboardData = async () => {
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}dashboard`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
